import React from 'react'

function JobsTableHeader() {
    return (
        <thead className='JobsTableHeader' style={{ background: '#e9ecef' }}>
            <tr>
                <th>Job</th>
                <th>Người tạo</th>
                <th>Hệ thống</th>
                <th>Service</th>
                <th>Trạng thái</th>
                <th>Số lần thử lại</th>
                <th>Created</th>
                <th>Updated </th>
                <th>File tải về</th>
                <th>Tham số</th>
                <th>Action</th>
            </tr>
        </thead>
    )
}

export default JobsTableHeader